/* RZT · comportements de page. Aucune dépendance. */
(function () {
  'use strict';

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var fine = window.matchMedia('(hover: hover) and (pointer: fine)').matches;

  /* --- courbe de lactate interactive ----------------------------------
     Trois profils morphent la courbe (les seuils se déplacent), et le
     pointeur lit la valeur de lactate à l'intensité survolée.
     Doit s'exécuter avant l'observer : il fige la longueur des tracés. */
  Array.prototype.forEach.call(document.querySelectorAll('[data-curve]'), function (root) {
    var path = root.querySelector('[data-path]');
    if (!path) return;
    var X0 = 70, X1 = 760, YB = 350, SC = 34.5, N = 120;
    var el = {
      z1: root.querySelector('[data-z1]'), z2: root.querySelector('[data-z2]'), z3: root.querySelector('[data-z3]'),
      t1: root.querySelector('[data-thr1]'), t2: root.querySelector('[data-thr2]'),
      d1: root.querySelector('[data-dot1]'), d2: root.querySelector('[data-dot2]'),
      l1: root.querySelector('[data-lbl1]'), l2: root.querySelector('[data-lbl2]'),
      sg: root.querySelector('[data-scrub-g]'), sl: root.querySelector('[data-sline]'),
      sd: root.querySelector('[data-sdot]'), read: root.querySelector('[data-read]')
    };
    var readDefault = el.read ? el.read.textContent : '';

    var PROFILES = {
      debutant: { s1: .36, s2: .56 },
      confirme: { s1: .50, s2: .75 },
      elite:    { s1: .63, s2: .86 }
    };

    /* interpolation cubique monotone sur 4 points d'ancrage */
    function makeCurve(p) {
      var xs = [0, p.s1, p.s2, 1];
      var ys = [1.2, 2, 4, Math.min(9, 4 + (1 - p.s2) * 11)];
      var n = xs.length, d = [], m = [], i;
      for (i = 0; i < n - 1; i++) d.push((ys[i + 1] - ys[i]) / (xs[i + 1] - xs[i]));
      m[0] = d[0]; m[n - 1] = d[n - 2];
      for (i = 1; i < n - 1; i++) m[i] = d[i - 1] * d[i] <= 0 ? 0 : (d[i - 1] + d[i]) / 2;
      for (i = 0; i < n - 1; i++) {
        if (!d[i]) { m[i] = 0; m[i + 1] = 0; continue; }
        var a = m[i] / d[i], b = m[i + 1] / d[i], h = Math.sqrt(a * a + b * b);
        if (h > 3) { m[i] = 3 * d[i] * a / h; m[i + 1] = 3 * d[i] * b / h; }
      }
      var f = function (x) {
        var j = n - 2, k;
        for (k = 0; k < n - 1; k++) { if (x <= xs[k + 1]) { j = k; break; } }
        var hh = xs[j + 1] - xs[j], t = (x - xs[j]) / hh, t2 = t * t, t3 = t2 * t;
        return (2 * t3 - 3 * t2 + 1) * ys[j] + (t3 - 2 * t2 + t) * hh * m[j]
             + (-2 * t3 + 3 * t2) * ys[j + 1] + (t3 - t2) * hh * m[j + 1];
      };
      var out = [];
      for (i = 0; i <= N; i++) out.push(f(i / N));
      return out;
    }

    function xPx(f) { return X0 + f * (X1 - X0); }
    function yPx(mmol) { return Math.max(42, YB - mmol * SC); }
    function pathFrom(sam) {
      var s = 'M' + xPx(0).toFixed(1) + ' ' + yPx(sam[0]).toFixed(1);
      for (var i = 1; i <= N; i++) s += 'L' + xPx(i / N).toFixed(1) + ' ' + yPx(sam[i]).toFixed(1);
      return s;
    }

    var cur = { sam: makeCurve(PROFILES.confirme), s1: .5, s2: .75 };

    function paint() {
      path.setAttribute('d', pathFrom(cur.sam));
      var x1 = xPx(cur.s1), x2 = xPx(cur.s2);
      if (el.z1) { el.z1.setAttribute('width', (x1 - X0).toFixed(1)); }
      if (el.z2) { el.z2.setAttribute('x', x1.toFixed(1)); el.z2.setAttribute('width', (x2 - x1).toFixed(1)); }
      if (el.z3) { el.z3.setAttribute('x', x2.toFixed(1)); el.z3.setAttribute('width', (X1 - x2).toFixed(1)); }
      [[el.t1, x1], [el.t2, x2], [el.d1, x1], [el.d2, x2], [el.l1, x1], [el.l2, x2]].forEach(function (pair) {
        var node = pair[0], x = pair[1].toFixed(1);
        if (!node) return;
        if (node.tagName === 'line') { node.setAttribute('x1', x); node.setAttribute('x2', x); }
        else if (node.tagName === 'circle') { node.setAttribute('cx', x); }
        else { node.setAttribute('x', x); }
      });
    }
    paint();

    var anim = null;
    function morphTo(key) {
      var target = { sam: makeCurve(PROFILES[key]), s1: PROFILES[key].s1, s2: PROFILES[key].s2 };
      /* le tracé change : on abandonne l'animation de dessin initial */
      path.classList.remove('draw');
      path.style.strokeDasharray = 'none';
      path.style.strokeDashoffset = '0';
      if (reduce) { cur = target; paint(); return; }
      var from = { sam: cur.sam.slice(), s1: cur.s1, s2: cur.s2 };
      var t0 = null;
      if (anim) cancelAnimationFrame(anim);
      function step(ts) {
        if (!t0) t0 = ts;
        var t = Math.min(1, (ts - t0) / 480);
        var e = 1 - Math.pow(1 - t, 3);
        cur.s1 = from.s1 + (target.s1 - from.s1) * e;
        cur.s2 = from.s2 + (target.s2 - from.s2) * e;
        for (var i = 0; i <= N; i++) cur.sam[i] = from.sam[i] + (target.sam[i] - from.sam[i]) * e;
        paint();
        if (t < 1) anim = requestAnimationFrame(step);
      }
      anim = requestAnimationFrame(step);
    }

    var chips = Array.prototype.slice.call(root.querySelectorAll('[data-profile]'));
    chips.forEach(function (c) {
      c.addEventListener('click', function () {
        chips.forEach(function (o) {
          var on = o === c;
          o.classList.toggle('is-on', on);
          o.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
        morphTo(c.getAttribute('data-profile'));
      });
    });

    /* lecture au pointeur */
    var svg = root.querySelector('svg');
    function zoneName(f) {
      return f < cur.s1 ? 'zone 1 · endurance' : f < cur.s2 ? 'zone 2 · tempo' : 'zone 3 · haute intensité';
    }
    svg.addEventListener('pointermove', function (ev) {
      var r = svg.getBoundingClientRect();
      var x = (ev.clientX - r.left) / r.width * 800;
      if (x < X0 || x > X1) return;
      var f = (x - X0) / (X1 - X0);
      var mmol = cur.sam[Math.round(f * N)];
      var y = yPx(mmol);
      if (el.sg) el.sg.removeAttribute('hidden');
      if (el.sl) { el.sl.setAttribute('x1', x.toFixed(1)); el.sl.setAttribute('x2', x.toFixed(1)); el.sl.setAttribute('y1', y.toFixed(1)); }
      if (el.sd) { el.sd.setAttribute('cx', x.toFixed(1)); el.sd.setAttribute('cy', y.toFixed(1)); }
      if (el.read) el.read.textContent = 'Intensité ' + Math.round(f * 100) + ' % · ' + mmol.toFixed(1).replace('.', ',') + ' mmol/L · ' + zoneName(f);
    });
    svg.addEventListener('pointerleave', function () {
      if (el.sg) el.sg.setAttribute('hidden', '');
      if (el.read) el.read.textContent = readDefault;
    });
  });

  /* --- texte qui s'allume au défilement (manifeste) -------------------- */
  var scrubs = Array.prototype.slice.call(document.querySelectorAll('[data-scrub]'));
  if (scrubs.length && !reduce) {
    scrubs.forEach(function (elx) {
      var words = elx.textContent.trim().split(/\s+/);
      elx.textContent = '';
      words.forEach(function (w, i) {
        var s = document.createElement('span');
        s.className = 'scrub-w';
        s.style.setProperty('--i', i);
        s.textContent = w;
        elx.appendChild(s);
        elx.appendChild(document.createTextNode(' '));
      });
      elx.style.setProperty('--n', words.length);
    });
    var ticking = false;
    var onScroll = function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        ticking = false;
        var vh = window.innerHeight;
        scrubs.forEach(function (elx) {
          var r = elx.getBoundingClientRect();
          if (r.top > vh || r.bottom < 0) return;
          var p = Math.max(0, Math.min(1, (vh * 0.85 - r.top) / (vh * 0.6)));
          elx.style.setProperty('--p', p.toFixed(3));
        });
      });
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* --- boutons magnétiques -------------------------------------------- */
  if (fine && !reduce) {
    Array.prototype.forEach.call(document.querySelectorAll('.btn--lg, .btn--ghost'), function (b) {
      b.addEventListener('pointermove', function (ev) {
        var r = b.getBoundingClientRect();
        var dx = (ev.clientX - r.left - r.width / 2) / r.width;
        var dy = (ev.clientY - r.top - r.height / 2) / r.height;
        b.style.transform = 'translate(' + (dx * 9).toFixed(1) + 'px,' + (dy * 6).toFixed(1) + 'px)';
      });
      b.addEventListener('pointerleave', function () { b.style.transform = ''; });
    });
  }

  /* --- la maquette téléphone suit le curseur --------------------------- */
  var phone = document.querySelector('.phone');
  if (phone && fine && !reduce) {
    var pWrap = phone.parentElement;
    pWrap.style.perspective = '1100px';
    pWrap.addEventListener('pointermove', function (ev) {
      var r = pWrap.getBoundingClientRect();
      var dx = (ev.clientX - r.left) / r.width - .5;
      var dy = (ev.clientY - r.top) / r.height - .5;
      phone.style.transform = 'rotateY(' + (dx * 9).toFixed(1) + 'deg) rotateX(' + (-dy * 7).toFixed(1) + 'deg)';
    });
    pWrap.addEventListener('pointerleave', function () { phone.style.transform = ''; });
  }

  /* --- rail horizontal : glisser à la souris --------------------------- */
  Array.prototype.forEach.call(document.querySelectorAll('.snaprail'), function (rail) {
    var down = false, sx = 0, sl = 0;
    rail.addEventListener('pointerdown', function (ev) {
      if (ev.pointerType !== 'mouse') return;
      down = true; sx = ev.clientX; sl = rail.scrollLeft;
      rail.classList.add('is-drag');
    });
    window.addEventListener('pointermove', function (ev) {
      if (!down) return;
      rail.scrollLeft = sl - (ev.clientX - sx);
    });
    window.addEventListener('pointerup', function () {
      down = false; rail.classList.remove('is-drag');
    });
  });

  /* --- révélations au défilement ------------------------------------- */
  var targets = document.querySelectorAll('.rise, .rise--mask, .draw, .fadein');

  if (reduce || !('IntersectionObserver' in window)) {
    targets.forEach(function (el) { el.classList.add('in'); });
  } else {
    /* Longueur réelle des tracés, pour un dessin propre. On ne CACHE que les
       tracés encore sous la fenêtre : celui qui est déjà à l'écran au chargement
       reste dessiné, il n'y a rien à révéler. */
    var aTracer = [];
    document.querySelectorAll('path.draw, line.draw, polyline.draw').forEach(function (p) {
      if (typeof p.getTotalLength === 'function') {
        p.style.setProperty('--len', Math.ceil(p.getTotalLength()));
      }
      if (p.getBoundingClientRect().top > window.innerHeight) {
        p.classList.add('a-tracer');
        aTracer.push(p);
      }
    });
    /* Filet de sécurité : au bout de huit secondes, tout tracé encore caché est
       rendu, quoi qu'il soit arrivé à l'observer. Un schéma qui porte du sens ne
       reste jamais invisible à cause d'une animation. */
    setTimeout(function () {
      aTracer.forEach(function (p) { if (!p.classList.contains('in')) p.classList.remove('a-tracer'); });
    }, 8000);

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        e.target.classList.add('in');
        io.unobserve(e.target);
      });
    }, { rootMargin: '0px 0px -12% 0px', threshold: 0.15 });

    targets.forEach(function (el) { io.observe(el); });
  }

  /* --- ruban d'athlètes : la piste doit couvrir la fenêtre ---------------
     L'animation fait glisser la piste de sa PROPRE largeur (`translateX(-100%)`).
     La boucle n'est donc continue que si la piste est au moins aussi large que
     son conteneur. Avec cinq athlètes elle mesure 1 594 px : au-delà de 1 900 px
     de fenêtre, la fin de boucle laissait un vide blanc, jusqu'à 966 px à
     2 560 px de large.

     On complète donc chaque piste par des copies des articles jusqu'à dépasser
     la fenêtre, et on allonge la durée dans la même proportion pour que la
     vitesse de défilement ne change pas d'un écran à l'autre. */
  document.querySelectorAll('.ruban').forEach(function (ruban) {
    var pistes = Array.prototype.slice.call(ruban.querySelectorAll('.ruban__piste'));
    if (!pistes.length) return;

    /* on mémorise la série d'origine avant toute copie */
    var modele = Array.prototype.slice.call(pistes[0].children).map(function (n) {
      return n.cloneNode(true);
    });
    if (!modele.length) return;
    var DUREE = 46;   /* secondes, pour la largeur d'origine */

    function ajuste() {
      var large = ruban.clientWidth;
      pistes.forEach(function (piste) {
        /* remise à la série d'origine, sinon les copies s'accumulent au redimensionnement */
        piste.innerHTML = '';
        modele.forEach(function (n) { piste.appendChild(n.cloneNode(true)); });

        var base = piste.scrollWidth;
        if (!base) return;
        var copies = Math.max(1, Math.ceil((large + 1) / base));
        for (var i = 1; i < copies; i++) {
          modele.forEach(function (n) {
            var c = n.cloneNode(true);
            c.setAttribute('aria-hidden', 'true');
            piste.appendChild(c);
          });
        }
        /* la piste est `copies` fois plus longue : même vitesse au pixel près */
        piste.style.animationDuration = (DUREE * copies) + 's';
      });
    }

    ajuste();
    var attente;
    window.addEventListener('resize', function () {
      clearTimeout(attente);
      attente = setTimeout(ajuste, 180);
    });
  });

  /* --- bandeaux vidéo --------------------------------------------------
     `autoplay` est dans le markup pour que la bande vive même sans JS. En
     mouvement réduit, on l'arrête : l'attribut seul ne suffit pas, il faut
     mettre la lecture en pause après coup. */
  if (reduce) {
    document.querySelectorAll('video[autoplay]').forEach(function (v) {
      v.removeAttribute('autoplay'); v.pause(); v.currentTime = 0;
    });
  }

  /* --- remplissage des numéros de la pile ------------------------------
     Les cartes sont collantes : `animation-timeline: view()` s'y fige dès
     qu'elles se collent, et le chiffre reste à moitié rempli. On observe
     donc la carte elle-même et on remplit son numéro quand elle occupe
     plus de la moitié de l'écran. */
  var cartes = document.querySelectorAll('.pile__card');
  if (cartes.length) {
    if (reduce || !('IntersectionObserver' in window)) {
      document.querySelectorAll('.pile__n').forEach(function (n) { n.classList.add('is-plein'); });
    } else {
      var ioP = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (!e.isIntersecting) return;
          var n = e.target.querySelector('.pile__n');
          if (n) n.classList.add('is-plein');
          ioP.unobserve(e.target);
        });
      }, { threshold: 0.55 });
      cartes.forEach(function (c) { ioP.observe(c); });
    }
  }

  /* --- onglets (application) ------------------------------------------ */
  document.querySelectorAll('[data-tabs]').forEach(function (root) {
    var tabs = Array.prototype.slice.call(root.querySelectorAll('[role="tab"]'));
    var panels = Array.prototype.slice.call(root.querySelectorAll('[role="tabpanel"]'));
    if (!tabs.length) return;

    function select(i) {
      tabs.forEach(function (t, j) {
        var on = i === j;
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.setAttribute('tabindex', on ? '0' : '-1');
        panels[j].hidden = !on;
      });
    }

    tabs.forEach(function (t, i) {
      t.addEventListener('click', function () { select(i); });
      /* au survol, le panneau suit : on découvre chaque fonction sans cliquer.
         Réservé au pointeur fin, sinon un effleurement changerait l'onglet. */
      if (fine) { t.addEventListener('pointerenter', function () { select(i); }); }
      t.addEventListener('keydown', function (ev) {
        var dir = ev.key === 'ArrowRight' || ev.key === 'ArrowDown' ? 1
                : ev.key === 'ArrowLeft' || ev.key === 'ArrowUp' ? -1 : 0;
        if (!dir) return;
        ev.preventDefault();
        var next = (i + dir + tabs.length) % tabs.length;
        select(next);
        tabs[next].focus();
      });
    });

    select(0);
  });

  /* --- fiche produit : galerie et quantité ----------------------------- */
  Array.prototype.forEach.call(document.querySelectorAll('[data-shop]'), function (shop) {
    var mainImg = shop.querySelector('[data-shop-img]');
    var cadre = shop.querySelector('.shop__main');
    var thumbs = Array.prototype.slice.call(shop.querySelectorAll('[data-shop-thumb]'));

    /* Une fiche peut n'avoir aucune photo : les trois fiches du lecteur sont
       désormais couvertes par la bande produit qui les précède. Seuls le prix
       et la quantité restent à câbler. */
    if (mainImg) {
      /* Le cadre épouse le rapport de la photo affichée, borné entre portrait
         4/5 et paysage 3/2 : les photos produit vont du portrait étroit au
         paysage, un cadre fixe laisserait de grandes bandes vides. */
      var ajusteCadre = function () {
        /* une fiche peut figer son cadre (classe .shop--fixe) : on la laisse faire */
        if (shop.classList.contains('shop--fixe')) return;
        if (!cadre || !mainImg.naturalWidth) return;
        var r = mainImg.naturalWidth / mainImg.naturalHeight;
        cadre.style.aspectRatio = Math.max(0.74, Math.min(1.5, r)).toFixed(3);
      };
      mainImg.addEventListener('load', ajusteCadre);
      if (mainImg.complete) ajusteCadre();
    }

    /* les vignettes prennent aussi le rapport de leur image : un cadre fixe
       laissait de grandes bandes vides sur les photos paysage du lecteur */
    thumbs.forEach(function (t) {
      var im = t.querySelector('img');
      if (!im) return;
      var pose = function () {
        if (shop.classList.contains('shop--fixe')) return;
        if (!im.naturalWidth) return;
        var r = im.naturalWidth / im.naturalHeight;
        t.style.aspectRatio = Math.max(0.74, Math.min(1.5, r)).toFixed(3);
      };
      im.addEventListener('load', pose);
      if (im.complete) pose();
    });

    function choisir(t) {
      mainImg.src = t.getAttribute('data-src');
      mainImg.alt = t.getAttribute('data-alt') || '';
      thumbs.forEach(function (o) { o.classList.toggle('is-on', o === t); });
    }
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () { choisir(t); });
    });

    /* Les flèches posées sur le grand cadre feuillettent la même liste que les
       vignettes, en boucle. Elles sont dans le cadre, pas dans un lien : rien
       à intercepter, mais on garde le `preventDefault` au cas où la fiche
       passerait un jour sous un lien. */
    ['[data-vue-prec]', '[data-vue-suiv]'].forEach(function (sel, sens) {
      var b = shop.querySelector(sel);
      if (!b || thumbs.length < 2) return;
      b.addEventListener('click', function (e) {
        e.preventDefault();
        var i = thumbs.findIndex(function (t) { return t.classList.contains('is-on'); });
        if (i < 0) i = 0;
        choisir(thumbs[(i + (sens ? 1 : -1) + thumbs.length) % thumbs.length]);
      });
    });

    /* Sur Shopify, le prix vient du SERVEUR (`{{ variant.price | money }}`) et
       la quantité est un `<input name="quantity">` que le formulaire poste.
       La fiche ne porte alors pas de `data-unit` : le calcul de prix côté JS
       est éteint, sans quoi il écrasait le prix rendu par un `0,00 €`. Le
       sélecteur de quantité, lui, reste câblé dans les deux cas. */
    var unit = parseFloat(shop.getAttribute('data-unit') || '0');
    var compareUnit = parseFloat(shop.getAttribute('data-compare-unit') || '0');
    var prixCalcule = shop.hasAttribute('data-unit');
    var qtyEl = shop.querySelector('[data-qty]');
    var champQte = qtyEl && qtyEl.tagName === 'INPUT';
    var qty = champQte ? (parseInt(qtyEl.value, 10) || 1) : 1;
    var totalEls = shop.querySelectorAll('[data-total]');
    var compareEl = shop.querySelector('[data-compare]');
    function euros(n) { return n.toFixed(2).replace('.', ',') + ' €'; }
    function render() {
      if (!qtyEl) return;
      if (champQte) { qtyEl.value = qty; } else { qtyEl.textContent = qty; }
      if (!prixCalcule) return;
      totalEls.forEach(function (el) { el.textContent = euros(unit * qty); });
      if (compareEl && compareUnit) { compareEl.textContent = euros(compareUnit * qty); }
    }
    var moins = shop.querySelector('[data-minus]');
    var plus = shop.querySelector('[data-plus]');
    if (moins) moins.addEventListener('click', function () { if (qty > 1) { qty -= 1; render(); } });
    if (plus) plus.addEventListener('click', function () { if (qty < 20) { qty += 1; render(); } });
    if (champQte) qtyEl.addEventListener('change', function () {
      qty = Math.max(1, Math.min(20, parseInt(qtyEl.value, 10) || 1)); render();
    });
    render();
  });

  /* --- taille du texte des graphes ------------------------------------
     Un SVG à viewBox met son texte à l'échelle de son cadre : les libellés
     d'axe tombaient à 5 px sur un téléphone et montaient à 27 px sur un grand
     écran. On pose le facteur inverse en variable CSS, borné pour qu'un cadre
     minuscule ne fasse pas exploser le libellé. */
  var graphes = document.querySelectorAll('svg.chart');
  if (graphes.length) {
    var caleGraphe = function (svg) {
      var vb = svg.viewBox && svg.viewBox.baseVal ? svg.viewBox.baseVal.width : 0;
      var l = svg.getBoundingClientRect().width;
      if (!vb || !l) return;
      var k = vb / l;
      svg.style.setProperty('--chart-k', Math.min(3, Math.max(0.55, k)).toFixed(3));
    };
    Array.prototype.forEach.call(graphes, caleGraphe);
    if (window.ResizeObserver) {
      var ro = new ResizeObserver(function (entrees) {
        entrees.forEach(function (e) { caleGraphe(e.target); });
      });
      Array.prototype.forEach.call(graphes, function (g) { ro.observe(g); });
    } else {
      window.addEventListener('resize', function () {
        Array.prototype.forEach.call(graphes, caleGraphe);
      });
    }
  }

  /* --- formulaire structures : validation en ligne --------------------- */
  var form = document.querySelector('[data-form]');
  if (form) {
    var note = form.querySelector('[data-form-note]');
    form.addEventListener('submit', function (ev) {
      ev.preventDefault();
      var ok = form.checkValidity();
      if (!ok) { form.reportValidity(); return; }
      if (note) {
        note.textContent = 'Démonstration : le formulaire n’est pas encore relié. Écrivez à contact@rzt-sport.com en attendant.';
        note.hidden = false;
      }
    });
  }


  /* --- afficheur du hero -----------------------------------------------
     Rejoue la promesse du produit : cinq secondes de mesure, puis la valeur
     et sa zone. Une seule fois, quand le hero entre a l'ecran. */
  var mes = document.querySelector('[data-mesure]');
  if (mes) {
    var val = mes.querySelector('[data-val]');
    var zone = mes.querySelector('[data-zone]');
    var jauge = mes.querySelector('[data-jauge]');
    var CIBLE = 2.4, DUREE = 2600;

    function pose(v) { val.textContent = v.toFixed(1).replace('.', ','); }

    function joue() {
      if (reduce) {
        pose(CIBLE); zone.textContent = 'Zone 2 · tempo';
        if (jauge) jauge.style.width = '100%';
        return;
      }
      var t0 = null;
      (function pas(ts) {
        if (!t0) t0 = ts;
        var p = Math.min(1, (ts - t0) / DUREE);
        var e = 1 - Math.pow(1 - p, 3);
        pose(CIBLE * e);
        if (jauge) jauge.style.width = (e * 100).toFixed(1) + '%';
        if (p < 1) { requestAnimationFrame(pas); }
        else { zone.textContent = 'Zone 2 · tempo'; }
      });
      requestAnimationFrame(function (ts) {
        t0 = ts;
        (function boucle(t) {
          var p = Math.min(1, (t - t0) / DUREE);
          var e = 1 - Math.pow(1 - p, 3);
          pose(CIBLE * e);
          if (jauge) jauge.style.width = (e * 100).toFixed(1) + '%';
          if (p < 1) requestAnimationFrame(boucle);
          else zone.textContent = 'Zone 2 · tempo';
        })(ts);
      });
    }

    if (!('IntersectionObserver' in window)) { joue(); }
    else {
      var ioM = new IntersectionObserver(function (es) {
        es.forEach(function (e) {
          if (!e.isIntersecting) return;
          ioM.unobserve(e.target);
          setTimeout(joue, 700);
        });
      }, { threshold: 0.4 });
      ioM.observe(mes);
    }
  }
})();
